import dayjs from "dayjs";

/** 전1주 세팅 버튼 */
export const beforeWeek = (
  search: any,
  setSearchData: any,
  setSearchConfirm?: any
) => {
  const startDate = new Date();
  startDate.setDate(startDate.getDate() - 7);
  const endDate = new Date();
  endDate.setDate(endDate.getDate() - 1);

  setSearchData?.("startDate", startDate.toISOString().split("T")[0]);
  setSearchData?.("endDate", endDate.toISOString().split("T")[0]);

  // 검색전송 트리거 상태값 변경
  setSearchConfirm?.({
    ...search,
    startDate: startDate.toISOString().split("T")[0],
    endDate: endDate.toISOString().split("T")[0],
  });
};

export const beforeWeekTime = (
  search: any,
  setSearchData: any,
  days: number,
  setSearchConfirm?: any
) => {
  const startDate = dayjs()
    .subtract(days, "days")
    .format("YYYY-MM-DD 00:00:00");
  const endDate = dayjs().format("YYYY-MM-DD 23:59:59");

  setSearchData?.("startDate", startDate);
  setSearchData?.("endDate", endDate);

  // 검색전송 트리거 상태값 변경
  setSearchConfirm?.({
    ...search,
    startDate: startDate,
    endDate: endDate,
  });
};
